import {
  AccountInfo,
  IPublicClientApplication,
  PublicClientApplication,
} from "@azure/msal-browser";
import { terminateTokens } from "./api/utils/localStorage";

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_SSO_CLIENT_ID,
    authority: import.meta.env.VITE_SSO_AUTHORITY,
    knownAuthorities: [import.meta.env.VITE_SSO_KNOWN_AUTHORITIES],
    redirectUri: import.meta.env.VITE_SSO_REDIRECT_URI,
    postLogoutRedirectUri: import.meta.env.VITE_SSO_POST_LOGOUT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const SCOPES = [
  "openid",
  "profile",
  "email",
  "offline_access",
  import.meta.env.VITE_SSO_CLIENT_ID,
];

export const getSSOAccessToken = async (
  instance: IPublicClientApplication,
  account: AccountInfo,
  scopes: string[],
) => {
  try {
    const res = await instance.acquireTokenSilent({ account, scopes });
    return res.accessToken;
  } catch (e: any) {
    if (e?.errorCode === "interaction_required") {
      const res = await instance.acquireTokenPopup({ scopes, prompt: "login" });
      return res.accessToken;
    }
    throw e;
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const logoutSSO = async () => {
  try {
    await msalInstance.logoutRedirect({
      account: msalInstance.getActiveAccount() ?? undefined,
      postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
    });
  } catch (e) {
    console.error("Logout failed:", e);
  } finally {
    terminateTokens();
    sessionStorage.clear();
  }
};
